import axios from 'axios';
import { batch } from 'react-redux';
import { UserAgent, Registerer, Inviter, SessionState } from 'sip.js'; // npm install sip.js

import { queryClient } from '../state/queryClient';
import { findclientfromtel } from './phone';
import {  store, modifyMessagetel, modifyDisplaymodal, modifyEtattel,
        modifyRingfirst, modifyQualiflead, initialiseLeadactu, initialiseLeadappelant, 
        modifyEcran, allFormules, defineDevisFormules  } from '../state/redux';

import { modifyonelead } from './actions_lead';
// DEV TELEPHONE     
// Structure pour stocker l'instance SIP
let tel = {
    userAgent: null,
    registerer: null,
    session: null, // Correspond à la "connexion" siptel
    config: null
};

export const telephone = {
    failedrequest: false,
    getTelephone: () => tel,
    setTelephone: (t) => { tel = t }
}

// Helper pour formater le numéro vers Asterisk
function convertToSip(num) {
    const numero = num?.replace(/([ .])/g, "");
    return numero; // SIP gère souvent mieux le format local ou international pur
}

async function updatestatustel(etat) {
    return etat ;
    // if (telephone.failedrequest === true) return;
    // const user = queryClient.getQueryData(['user', localStorage.getItem('token')]);
    // try {
    //     await axios.post(`/voip/updatesatusphone/`, { 'telephone': user['telephone'], 'status': etat });
    // } catch (err) {
    //     if (err.code?.includes('ERR_NETWORK')) { telephone.failedrequest = true }
    // }
}

// Gestion des événements de session (Appel en cours)
export const handleSessionEvents = (session) => {
    session.stateChange.addListener((newState) => {
        switch (newState) {
            case SessionState.Established:
                console.log("Appel établi");
                updatestatustel('busy');
                break;
            case SessionState.Terminated:
                console.log("Appel terminé");
                const event = new Event('postappel');
                window.dispatchEvent(event);
                raccrochageintempestif();
                break;
        }
    });

    // Gestion du flux audio distant
    const remoteStream = new MediaStream();
    session.sessionDescriptionHandler.peerConnection.getReceivers().forEach((receiver) => {
        if (receiver.track) remoteStream.addTrack(receiver.track);
    });
    const remoteAudio = document.getElementById('remoteAudio'); // Nécessite un <audio id="remoteAudio" autoPlay />
    if (remoteAudio) remoteAudio.srcObject = remoteStream;
};

export async function initialisesiptel() { // Gardé le nom pour compatibilité avec ton reste de code

    console.log("Initialisation SIPTEL...");
    if (telephone.failedrequest === true) { window.location.reload(true); return }
    
    const user = queryClient.getQueryData(['user', localStorage.getItem('token')]);
    // DEV TEL
    //if (!user?.['telephone']) { console.log('PASDETEL'); return }

    updatestatustel('idle');

    // Étape 1 : Récupérer les credentials SIP (Login/Pass de l'extension) via ton API Node
    let sipCreds;
    // try {
    //     const res = await axios.get(`/voip/credentials/${user['telephone']}`);
    //     sipCreds = res.data; 
    // } catch (err) {
    //     telephone.failedrequest = true;
    //     return;
    // }

    // Étape 2 : Configuration du UserAgent SIP.js  
    const socket = new WebSocket(`wss://phone.mutuello.com:8089/ws`); // Port WSS par défaut de FreePBX
    
    const userAgent = new UserAgent({
        uri: UserAgent.makeURI(`sip:0978494650@phone.mutuello.com`),
        transportOptions: { server: `wss://phone.mutuello.com:8089/ws` },
        authorizationUsername: '0978494650',
        authorizationPassword: '$$secret$$',
        delegate: {
            onInvite: (invitation) => {
                console.log("Appel Entrant...");
                store.dispatch(modifyRingfirst(true));
                telephone.setTelephone({ ...telephone.getTelephone(), session: invitation });

                const callerNum = invitation.remoteIdentity.uri.user;
                store.dispatch(modifyMessagetel(callerNum));
                store.dispatch(modifyEtattel('sonnerie'));
                findclientfromtel(callerNum);
            }
        }
    });

    await userAgent.start();
    const registerer = new Registerer(userAgent);
    await registerer.register();

    telephone.setTelephone({ userAgent, registerer, session: null, config: sipCreds });
    store.dispatch(modifyEtattel('normal'));
}

export const phone = async (numtel) => {
    store.dispatch(modifyEtattel('appel'));
    const { userAgent } = telephone.getTelephone();
    const target = UserAgent.makeURI(`sip:${convertToSip(numtel)}@${telephone.getTelephone().config.server}`);

    const inviter = new Inviter(userAgent, target);
    telephone.setTelephone({ ...telephone.getTelephone(), session: inviter });
    
    handleSessionEvents(inviter);
    await inviter.invite();
    
    const nb = store.getState().lead.leadactu.nbappels || 0;
    modifyonelead({ 'nbappels': nb + 1 });
    updatestatustel('busy');
}

export const raccrocher_siptel = async () => {
    updatestatustel('idle');
    const { session } = telephone.getTelephone();
    
    if (session) {
        if (session.state === SessionState.Established) {
            await session.bye();
        } else {
            await session.cancel();
        }
    }

    telephone.setTelephone({ ...telephone.getTelephone(), session: null });
    batch(() => {
        store.dispatch(modifyEtattel('normal'));
        store.dispatch(modifyMessagetel(''));
        store.dispatch(initialiseLeadappelant({}));
    });
}

const raccrochageintempestif = () => {
    raccrocher_siptel();
    if (store.getState().lead.qualiflead === false && !store.getState().display.displaymodal?.includes('mod_qualiflead')) {
        store.dispatch(modifyDisplaymodal('mod_qualiflead'));
    }
}

export const rejectcall = async () => {
    const { session } = telephone.getTelephone();
    if (session && session.reject) {
        await session.reject();
    }
    store.dispatch(modifyMessagetel(null));
}

export const deccrocher = async () => {
    const { session } = telephone.getTelephone();
    store.dispatch(modifyQualiflead((store.getState().lead.leadappelant.id && store.getState().lead.leadappelant !== 'gagne') ? false : true));
    store.dispatch(allFormules([]));
    store.dispatch(defineDevisFormules([]));

    if (session) {
        handleSessionEvents(session);
        await session.accept();
    }

    updatestatustel('busy');
    store.dispatch(modifyMessagetel(null));
    batch(() => {
        store.dispatch(modifyEtattel('appel'));
        if (store.getState().lead.leadappelant.id) {
            store.dispatch(initialiseLeadactu(store.getState().lead.leadappelant));
            store.dispatch(modifyEcran('ficheclient'));
        }
    });
}
